import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SearchService } from '@services/search.service';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { AddService } from '@services/add.service';
import * as _ from 'lodash';
import { rotateInDownLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-mphoto',
  templateUrl: './mphoto.component.html',
  styleUrls: ['./mphoto.component.sass'],
  animations: [
    rotateInDownLeftOnEnterAnimation({ anchor: 'searchPage' })
  ]
})
export class MphotoComponent implements OnInit {
  album_btn_process = false;
  response: any = [];
  pageCounter = 1;
  totalRecord = 0;
  application = "photo";
  component = 'm';
  rows = 1;
  album_response: any = [];
  router_param: any = [];
  params: any = [];
  total_record = 0;
  pageno = 1;
  searchtxt = "";
  dataLoding = true;
  photoListForm: FormGroup;
  albumPhotoListForm: FormGroup;
  albumPhotoList: any = [];
  albums: any = [];
  album = "null";
  photos: any = [];
  constructor(private _addService: AddService, private _viewService: ViewService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private _searchService: SearchService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.photoListForm = this.fb.group({
      list: new FormArray([])
    });
    this.albumPhotoListForm = this.fb.group({
      list: new FormArray([])
    });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.route.queryParams.subscribe(params => {
      this.router_param = params;
      if (this.router_param['albumid']) {
        this.album = this.router_param['albumid'];
        this.getAlbum()
      }
    });
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      rows: this.rows
    };
    /*  this.route.queryParams.subscribe(params => {
       Object.entries(params).forEach(([key, value]) => {
         if (value) {
           p[key] = value;
         }
       });
     }); */

    this.loadAppData(p);
    this.loadAlbumList();

  }

  ngOnInit() {
    /* const queryParams = this.route.snapshot.queryParams
    const routeParams = this.route.snapshot.params; */
  }
  loadAlbumList() {
    let p = {
      component: this.component,
      application: 'album',
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      rows: this.rows
    };
    this._searchService.memberApplication(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.albums = this._global.getVal(data, 'response.docs', []);
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  loadAppData(p) {
    this.dataLoding = true;
    this._searchService.memberApplication(p).subscribe(
      data => {
        this.dataLoding = false;
        this.params = this._global.getVal(data, 'request', '');
        this.response = data["response"]["docs"];
        Object.entries(this.response).forEach(([key, value]) => {
          let control = this.fb.control('');
          (this.photoListForm.controls.list as FormArray).push(control);
        });
        this.total_record = this._global.getVal(data, 'response.numFound', '0');
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  albumAdd() {
    this.album_btn_process = true;
    let r = {};
    r['component'] = this.component;
    r['application'] = 'album';
    r['id'] = this.album;
    if (this.album != 'null') {
      let ids = [];
      Object.entries(this.photoListForm.value['list']).forEach(([key, value]) => {
        if (value) {
          ids.push(this.response[key]['id']);
        }
      });
      Object.entries(this.albumPhotoListForm.value['list']).forEach(([key, value]) => {
        if (value) {
          ids.push(this.albumPhotoList[key]['id']);
        }
      });
      r['mediaIds'] = ids.join(",");
      r = this._global.paramsRemoveNull(r);
      this._addService.application(r).subscribe(
        data => {
          this.album_btn_process = false;
          let severity = 'success';
          let message = '';
          if (this._global.getVal(data, 'status', '') == 1) {
            message = this._global.getVal(data, 'message.info', '');
            this._global.showMessage({ type: severity, message: message });
          } else {
            message = this._global.getVal(data, 'message.error', '');
            severity = 'warning';
            this._global.showMessage({ type: severity, message: message });
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    } else {
      this.album_btn_process = false;
      this._global.showMessage({ type: 'warning', message: 'Please Choose the album' });
    }
  }
  getAlbum() {
    this.albumPhotoList = [];
    this.album_response = [];
    this.dataLoding = true;
    this.albumPhotoListForm = this.fb.group({
      list: new FormArray([])
    });
    if (this.album != "null") {
      let p = {
        'component': this.component,
        'application': 'album',
        'id': this.album
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.album_response = this._global.getVal(data, 'response', '');
            Object.entries(this.album_response['photo']).forEach(([key, value]) => {
              value = this._global.asJsonObject(value);
              let r = {
                mediaType: "photo",
                uid: key,
                id: key,
                name: value['name']
              }
              this.albumPhotoList.push(r);
              let control = this.fb.control(true);
              (this.albumPhotoListForm.controls.list as FormArray).push(control);
            });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });

    }
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.memberApplication(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
              Object.entries(data["response"]["docs"]).forEach(([key, value]) => {
                let control = this.fb.control('');

                (this.photoListForm.controls.list as FormArray).push(control);
              });
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }
  searchMedia(event: any) {
    this.dataLoding = true;
    this.response = [];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      name: this.searchtxt,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      rows: this.rows
    };
    this.loadAppData(p);
  }
}
